"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.items', function () {
    this.data = [];
    this.frames = {};
    this.init = function () {
        var _this = this;
        var defArr = [jquery_1.default.Deferred(), jquery_1.default.Deferred()];
        this.setItemSpace(defArr[0]);
        this.updateCodeBase(defArr[1]);
        jquery_1.default.when.apply(this, defArr).then(function (ev) { return _this.start(ev); });
    };
    /*
        Depending on the id's of the apaOuterFrames, this function creates the namespaces ( e.g. apa.items.adler1 ) which are nessecary for the configs of the items
    */
    this.setItemSpace = function (deferred) {
        this.data.forEach(function (el) {
            namespace_1.default.namespace.extend('items.' + el.id, {});
        });
        deferred.resolve();
    };
    /*
        Passing trough the this.data array to redefine the codebases by attaching the string "apa.visual." before the codebase and reducing the codebase to the first element ( e.g. sport.tables.ranking leads to apa.visual.sport )
    */
    this.updateCodeBase = function (deferred) {
        this.data.forEach(function (el) {
            el.codebase = 'apa.visual.' + el.namespace;
        });
        deferred.resolve();
    };
    /*
        Checks the apaOuterFrames for attributes and writes them to the related config ( e.g. apa.items.adler1.config ).
        We also need to hand over the frameId ( e.g. adler1 ) to the init of the codebases, because every spine-based application needs to have access to the related config.
        Initializes the codebases of this.data ( e.g. apa.visual.sport.init, apa.visual.wahlen.init ).
    */
    this.start = function () {
        var _this = this;
        var hasIntersectionObserver = false;
        if ("IntersectionObserver" in window) {
            var intersectionObserver = new IntersectionObserver(function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    var frame = _this.frames[entry.target.id];
                    // If intersectionRatio is 0, the target is out of view
                    // and we do not need to do anything.
                    if (!entry.isIntersecting || frame.inited)
                        continue;
                    frame.inited = true;
                    _this.startFrame(frame);
                }
            }, { 'rootMargin': '500px 0px 500px 0px' });
            hasIntersectionObserver = true;
        }
        // start observing
        this.data.forEach(function (el) {
            if (hasIntersectionObserver) {
                _this.frames[el.id] = el;
                intersectionObserver.observe(document.querySelector('#' + el.id));
            }
            else {
                _this.startFrame(el);
            }
        });
    };
    this.startFrame = function (frame) {
        var tConfig = {
            frame: {},
            codebase: frame.codebase,
            namespace: frame.namespace,
        };
        document.querySelectorAll('#' + frame['id']).forEach(function (ele) {
            for (var i = 0; i < ele.attributes.length; i++) {
                tConfig.frame[ele.attributes[i].name] = ele.attributes[i].value;
            }
        });
        //@ts-ignore view and language are missing - they'll be added later
        namespace_1.default.items[frame.id].config = tConfig;
        var tPackage = namespace_1.default;
        frame.codebase.split('.').forEach(function (ele) {
            if (ele != 'apa') {
                tPackage = tPackage['' + ele];
            }
        });
        if (!tPackage.init) {
            namespace_1.default.debug.showError('Package ' + frame.namespace + ' has no init() function defined');
        }
        else {
            var tInit = new tPackage.init();
            tInit.frameId = frame['id'];
            tInit.namespace = frame.namespace;
            tInit.configure();
        }
    };
});
